exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".not-found-container{display:flex;padding:100px;justify-content:center;align-items:center;flex-direction:column}.not-found-container img{width:50%}\n", ""]);

